import TablePageContainer from 'components/TablePageContainer';
import useMobileBreakpoint from 'hooks/useMobileBreakpoint';
import useTrackPageLoad from 'hooks/useTrackPageLoad';
import StatsSummary from 'pages/Play/StatsSummary';
import { useState } from 'react';
import PodcastProvider from '../state/PodcastContext';
import MobileWarningCard from './MobileWarningCard';
import TableCard from './TableCard';
import TableTitle from './TableTitle';

type TableContainerProps = {};

const TableContainer: React.FC<TableContainerProps> = () => {
  useTrackPageLoad({
    section: 'Play',
    page: 'DefaultState',
    state: 'Populated',
  });

  const isMobile = useMobileBreakpoint('md');

  const [podcastId, setPodcastId] = useState<string>();

  const handleBackClick = () => setPodcastId(undefined);

  return (
    <PodcastProvider podcastId={podcastId}>
      <TablePageContainer>
        <TableTitle onBackClick={handleBackClick} />
        {podcastId && <StatsSummary />}
        {isMobile && podcastId && <MobileWarningCard />}
        <TableCard onSelectPodcast={setPodcastId} />
      </TablePageContainer>
    </PodcastProvider>
  );
};
export default TableContainer;
